import { IKeyObjective } from 'legacy/lut/classes/models/partner360/IFormOptionsJBP'

export type TKeyObjectiveHierarchyItem = IKeyObjective & {
  hasChildren: boolean
}

const hasOffering = ({ offerings }: IKeyObjective, offering: string | null) =>
  !offering || !offerings || offerings.split(',').some((item) => item.trim() === offering)

export const buildKeyObjectivesHierarchy = (
  keyObjectives: IKeyObjective[],
  offering: string | null
): TKeyObjectiveHierarchyItem[] => {
  const byKey = new Map(keyObjectives.map((el) => [el.key, el]))
  const visibleKeys = new Set<string>()

  // Keep every objective matching the offering plus its whole ancestor chain,
  // otherwise its descendants get orphaned and disappear from the tree.
  keyObjectives.forEach((el) => {
    if (!hasOffering(el, offering)) {
      return
    }

    let current: IKeyObjective | undefined = el

    while (current && !visibleKeys.has(current.key)) {
      visibleKeys.add(current.key)
      current = current.parent ? byKey.get(current.parent) : undefined
    }
  })

  const visible = keyObjectives.filter((el) => visibleKeys.has(el.key))

  return visible.map((el) => ({
    ...el,
    hasChildren: visible.some((child) => child.parent === el.key),
  }))
}
